import axios from "axios";
import authHeader from "./auth-header";
import { APP_URL } from "./http-common";

const URLEntityName = APP_URL + "file";

async function uploadFile(fileData) {
  return axios
    .post(URLEntityName + "/upload", fileData, {
      headers: authHeader(),
    })
    .then((response) => {
      return response.data;
    });
}

async function loadFile(id) {
  return axios
    .post(URLEntityName + "/" + id, null, {
      headers: authHeader(),
      responseType: "blob",

      "Content-Type": "application/octet-stream",
    })
    .then((response) => {
      const { data, headers } = response;

      var filenameDoc;
      var filename = "";
      const disposition = headers["content-disposition"];
      if (disposition && disposition.indexOf("attachment") !== -1) {
        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, "");
          filenameDoc = filename;
        }
      }

      const blobb = new Blob([response.data]);
      const url = window.URL.createObjectURL(blobb);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filenameDoc);
      document.body.appendChild(link);
      link.click();

      return response;
    });
}

async function loadUrlImage(id) {
  // per ti marr url  Image
  return axios
    .post(URLEntityName + "/" + id, null, {
      headers: authHeader(),
      responseType: "blob",
      // "Content-Type": "application/octet-stream",
    })
    .then(async (response) => {
      // const { data, headers } = response;

      // const blob = await response.blob();

      const url = URL.createObjectURL(response.data);

      // var filenameDoc;
      // var filename = "";
      // const disposition = headers["content-disposition"];
      // if (disposition && disposition.indexOf("attachment") !== -1) {
      //   var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      //   var matches = filenameRegex.exec(disposition);
      //   if (matches != null && matches[1]) {
      //     filename = matches[1].replace(/['"]/g, "");
      //     filenameDoc = filename;
      //   }
      // }

      // const blobb = new Blob([response.data]);
      // const url = URL.createObjectURL(blobb);
      return url;
    });
}

async function loadImage2(id) {
  try {
    const response = await fetch(URLEntityName + "/" + id, {
      method: "POST",
      headers: authHeader(),
    });

    if (!response.ok) throw new Error("Image fetch failed");

    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    return url;
    // setImageUrl(url);
  } catch (err) {
    console.error("Failed to load image", err);
  }
}

const uploadFileService = {
  uploadFile,
  loadFile,
  loadUrlImage,
  loadImage2,
};
export default uploadFileService;
